/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import moment from "moment";
import config from "../config";
import { uniqueId, isStringNumeric } from "./utils";
const haiaLeftDate = "2021-07-08";
// const sales2LeftDate = "2021-07-24";

let clientProductStates = {};
export default {
  getUsersBySearchKey: (searchKey, shouldGetMembers) => {
    return new Promise((resolve) => {
      const buildLink = buildGetReqUrl(config.getUsersSearchKeyEndpoint, {
        searchKey,
        shouldGetMembers: shouldGetMembers ? "&shouldGetMembers=" + shouldGetMembers : ""
      });
      axios.get(buildLink).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  searchByType: (querys) => {
    return new Promise((resolve) => {
      const buildUrl = buildGetReqUrl(config.getUsersSearchByTypesKeyEndpoint, querys);
      axios.get(buildUrl).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },
  generateUsersSearchExcelFile(querys) {
    //excel names for the generated file's filename
    const excelNames = { smooveExcel: "סמוב אקסל", fullExcel: "מסמך אקסל מלא" };

    return new Promise((resolve) => {
      const buildLink = buildGetReqUrl(config.getExcelFileUsersSearchTypesEndpoint, querys);

      axios.get(buildLink).then(async (serverRes) => {
        const excelData = serverRes?.data?.excelData;
        if (!excelData) return resolve({ err: "Problem with the request" });

        const { rows: data, header } = excelData;
        let fileName = `מיילים-`; //build informative file name
        fileName += `${excelNames?.[querys.excelType] ? `${excelNames?.[querys.excelType]}-` : ``}`;
        fileName += `בתאריך - ${moment(new Date()).format("DD-MM-YYYY:hh-mm")}`;
        // fileName += "csv";
        try {
          //create the csv file

          const csvRows = [];
          const headers = header;

          csvRows.push(headers.join(","));

          for (const row of data) {
            const values = headers.map((header) => {
              let val = row[header];
              if (!val) val = "";
              else if (typeof val === "number") val = "" + val;
              else if (isStringNumeric(row[header])) val = `\=\"${val}\"`; //like a phone number - -the \ and =  are to keep the leading zero
              const escaped = val.replace(/"/g, '""');
              return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
          }

          const csvFormat = csvRows.join("\n");
          // this BOM lets the file be hebrew
          const BOM = "\uFEFF";
          const blob = new Blob([BOM + csvFormat], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          return resolve({ success: true });
        } catch (err) {
          resolve({ err: "Problem with the request" });
        }
      });
    });
  },

  searchSimilarCard: (userId, userData) => {
    return new Promise((resolve) => {
      var similarVars = getSimilarVars(userData);
      axios.post(config.getSimilarCardsEndpoint, { userId, similarVars }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminUpdateUserData: (cardNum, updates, prevData, action) => {
    return new Promise((resolve) => {
      if (updates.email) updates.email = updates.email.replace(/  +/g, "");
      if (updates.officeName) updates.officeName = updates.officeName.trim();
      if (updates.fullName) updates.fullName = updates.fullName.trim().replace(/  +/g, " ");
      if (updates.mobile) updates.mobile = updates.mobile.replace(/[^\d\.]/g, "");

      axios.post(config.adminUpdateUserDataEndpoint, { cardNum, updates, prevData, action }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminDeleteUserCard: (cardNum) => {
    return new Promise((resolve) => {
      axios.post(config.deleteUserCardEndpoint, { cardNum }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  // comments, sales modifications
  adminUpdateUserComments: (itemBeingEditted, action, updateType) => {
    return new Promise((resolve) => {
      axios.post(config.adminUpdateUserCommentEndpoint, { itemBeingEditted, action, updateType }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminUpdateUserCommentLabel: (commentId, dateCreated, commentLabel) => {
    return new Promise((resolve) => {
      axios.post(config.adminUpdateUserCommentLabelEndpoint, { commentId, dateCreated, commentLabel }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  handleMemberUpdate: (memberNeedsAction, action, changesObj, originalMember) => {
    return new Promise((resolve) => {
      const dataForServer = { ...memberNeedsAction };
      if (dataForServer.email) dataForServer.email = dataForServer.email.replace(/\s/g, "").toLowerCase();
      if (dataForServer.email && !isValidEmail(dataForServer.email)) return resolve({ success: false, isInvalidEmail: true });
      if (dataForServer.firstName) dataForServer.firstName = dataForServer.firstName.trim().replace(/  +/g, " ");
      if (dataForServer.lastName) dataForServer.lastName = dataForServer.lastName.trim().replace(/  +/g, " ");
      if (dataForServer.fullName) dataForServer.fullName = dataForServer.fullName.trim().replace(/  +/g, " ");
      if (dataForServer.mobile) dataForServer.mobile = dataForServer.mobile.replace(/[^\d.]/g, "");

      const originalMemberForServer = originalMember ? { ...originalMember } : null;
      if (originalMemberForServer?.email) originalMemberForServer.email = originalMemberForServer.email.replace(/\s/g, "").toLowerCase();

      axios.post(config.adminMemberActionEndpoint, { memberNeedsAction: dataForServer, action, changesObj, originalMember: originalMemberForServer }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  initMemberReconf: (memberNeedsAction, action) => {
    return new Promise((resolve) => {
      axios.post(config.initMemberReconfEndpoint, { memberNeedsAction, action }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  resetStations: (cardNum, memberEmail, stationsAmount) => {
    return new Promise((resolve) => {
      axios
        .get(`${config.resetStationsEndpoint}?cardNum=${cardNum}&memberEmail=${memberEmail}&stationsAmount=${stationsAmount || 1}`)
        .then((serverRes) => {
          if (serverRes.data) return resolve(serverRes.data);
          resolve({ err: "Problem with the request" });
        });
    });
  },

  transferMemberToOtherCard: (data) => {
    return new Promise((resolve) => {
      axios.post(config.transferMemberToOtherCardEndpoint, data).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminUpdateDoc: (fd, queryForPost) => {
    return new Promise((resolve) => {
      axios.post(config.updateFileEndpoint + queryForPost, fd).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminSetDocDeleted: (nameWithExtension) => {
    return new Promise((resolve) => {
      axios.get(config.setDocDeletedEndpoint + "?nameWithExtension=" + nameWithExtension).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminTestDoc: (fd) => {
    return new Promise((resolve) => {
      axios.post(config.testDocEndpoint, fd).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminUpdateFieldData: (fieldData) => {
    return new Promise((resolve) => {
      axios.post(config.updateFieldEndpoint, fieldData).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminNewFieldData: (fieldKey) => {
    return new Promise((resolve) => {
      axios.post(config.newFieldEndpoint, { fieldKey }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  adminAddOrRemoveKeyFromDoc: (fieldKey, docKey, action) => {
    return new Promise((resolve) => {
      axios.post(config.addOrRemoveFieldFromDocEndpoint, { fieldKey, docKey, action }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  // this func will retrive sales accounts only if userId is provided (because we dont need the sales accounts for the personal assignment of a sales acc user page)
  salesListAndClientAssignments: (userId) => {
    return new Promise((resolve) => {
      userId = userId ? "?userId=" + userId : "";
      axios.get(config.salesListAndAssignmentsEndpoint + userId).then((serverRes) => {
        if (serverRes.data) {
          return resolve(serverRes.data);
        }

        resolve({ err: "Problem with the request" });
      });
    });
  },

  getFutureAssignmentsSalesUser: () => {
    return new Promise((resolve) => {
      axios.get(config.getFutureAssignmentsSalesUserEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getSalesAccountsList: () => {
    return new Promise((resolve) => {
      axios.get(config.getSalesAccountsListEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  setSalemanOwningUsers: (salesmanEmail, companyType, usersToOwn) => {
    return new Promise((resolve) => {
      axios.post(config.setSalesmanOwningUsersEndpoint, { salesmanEmail, companyType, usersToOwn }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getPendingUsers: () => {
    return new Promise((resolve) => {
      axios.get(config.getPendingUsersEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  handlePendingUser: (pendingUser, actionType, existingData) => {
    return new Promise((resolve) => {
      axios.post(config.handlePendingUserEndpoint, { pendingUser, actionType, existingData }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  addNewMemberFromCard: function (memberData) {
    return new Promise((resolve) => {
      axios.post(config.addNewMemberFromCardEndpoint, { memberData }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getCardSupportCases: function (cardNum) {
    return new Promise((resolve) => {
      axios.get(config.getCardSupportCasesEndpoint + "?cardNum=" + cardNum).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getAllOpenSupportCases: function () {
    return new Promise((resolve) => {
      axios.get(config.getAllOpenSupportCasesEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  pushNewSupport: function (supportReason, cardNum, givenOfficeName) {
    return new Promise((resolve) => {
      axios.post(config.pushNewSupportEndpoint, { supportReason, cardNum, givenOfficeName }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  updateSupportCase: function (supportCase) {
    return new Promise((resolve) => {
      axios.post(config.updateSupportEndpoint, { supportCase }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getEndingMemberships: function ({ startDate, endDate }) {
    return new Promise((resolve) => {
      axios.get(`${config.getEndingMembershipsEndpoint}?startDate=${startDate}&endDate=${endDate}`).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  logUserOut: function () {
    return new Promise((resolve) => {
      axios.get(config.logUserOutEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getSalesAccActivity: function (startDate, endDate, salesAccEmail) {
    return new Promise((resolve) => {
      axios
        .get(`${config.getSalesAccActivityEndpoint}?startDate=${startDate}&endDate=${endDate}&salesAccEmail=${salesAccEmail}`)
        .then((serverRes) => {
          const loginSessions = serverRes.data.tracking;
          const salesAndComments = serverRes.data.salesAndComments;
          const assignments = serverRes.data.assignments;
          const trackingData = [];
          for (let index = 0; index < loginSessions.length; index++) {
            let commentsArr = [];
            let salesArr = [];
            let assignmentsArr = [];
            let totalCounter = { comments: 0, sales: 0 };
            salesAndComments.forEach((item) => {
              const newComments = item.comments.filter((comment) => {
                if (index > 0) {
                  return (
                    comment.createdBy === loginSessions[index]?.belongsToUserEmail &&
                    new Date(comment.dateCreated) >= new Date(loginSessions[index].dateCreated) &&
                    new Date(comment.dateCreated) <= new Date(loginSessions[index - 1].dateCreated)
                  );
                } else {
                  return (
                    comment.createdBy === loginSessions[index]?.belongsToUserEmail &&
                    new Date(comment.dateCreated) >= new Date(loginSessions[index].dateCreated)
                  );
                }
              });

              const newSales = item.sales.filter((sale) => {
                if (index > 0) {
                  return (
                    sale.createdBy === loginSessions[index]?.belongsToUserEmail &&
                    new Date(sale.dateCreated) >= new Date(loginSessions[index].dateCreated) &&
                    new Date(sale.dateCreated) <= new Date(loginSessions[index - 1].dateCreated)
                  );
                } else {
                  return (
                    sale.createdBy === loginSessions[index]?.belongsToUserEmail &&
                    new Date(sale.dateCreated) >= new Date(loginSessions[index].dateCreated)
                  );
                }
              });

              totalCounter.comments = totalCounter.comments + newComments.length;
              totalCounter.sales = totalCounter.sales + newSales.length;
              commentsArr.push({ comments: newComments, cardNum: item.cardNum });
              salesArr.push({ sales: newSales, cardNum: item.cardNum });
            });

            assignments?.forEach((assignment) => {
              if (index > 0) {
                if (
                  assignment.createdBy === loginSessions[index]?.belongsToUserEmail &&
                  new Date(assignment.dateCreated) >= new Date(loginSessions[index].dateCreated) &&
                  new Date(assignment.dateCreated) <= new Date(loginSessions[index - 1].dateCreated)
                ) {
                  assignmentsArr.push(assignment);
                }
              } else {
                if (
                  assignment.createdBy === loginSessions[index]?.belongsToUserEmail &&
                  new Date(assignment.dateCreated) >= new Date(loginSessions[index].dateCreated)
                ) {
                  assignmentsArr.push(assignment);
                }
              }
            });
            totalCounter.assignments = assignmentsArr.length;
            totalCounter.membershipsChanges = loginSessions[index].membershipsChanges.length;

            let ticketsArr = [];
            loginSessions[index].ticketsAccessed.forEach((item, i) => {
              if (!ticketsArr.some((x) => x.ticket === item.ticket)) {
                ticketsArr.push({ ticket: item.ticket, times: [item.time] });
              } else {
                let curTicket = ticketsArr.findIndex((x) => x.ticket === item.ticket);
                ticketsArr[curTicket].times.push(item.time);
              }
            });
            loginSessions[index].ticketsAccessed = ticketsArr;

            trackingData.push({
              id: uniqueId(),
              user: loginSessions[index].belongsToUserEmail,
              comments: commentsArr,
              sales: salesArr,
              assignments: assignmentsArr,
              loginSessions: loginSessions[index],
              totalCounter
            });
          }
          if (serverRes.data) return resolve(trackingData);
          resolve({ err: "Problem with the request" });
        });
    });
  },

  // createdBy was supposed to be an email.. now its a name takes from the kaveret instead
  translateAdminName: function (createdBy, dateCreated) {
    switch (createdBy) {
      case "itaybkk10@gmail.com":
        return "איתי";
      case "sales5@b-tax.co.il":
        return "אלי";
      case "sales3@b-tax.co.il":
        return "תום";
      case "sales4@b-tax.co.il":
        if (!dateCreated || moment(dateCreated).isBefore(haiaLeftDate)) return "חיה";
        return "לירן";
      case "info@b-tax.co.il":
        return "מיכל";
      case "sales6@b-tax.co.il":
        return "איתן";
      case "sales2@b-tax.co.il":
        // if (!dateCreated || moment(dateCreated).isBefore(sales2LeftDate)) return "יובל";
        return "זוהר";

      default:
        return createdBy.includes("@") ? createdBy.substring(0, createdBy.indexOf("@")) : createdBy;
    }
  },

  getProductList: function () {
    return [
      { productType: "ביטקס חודשי", price: "250" },
      { productType: "ביטקס חודשי מתחדש", price: "250" },
      { productType: "ביטקס חצי שנתי", price: "1400" },
      { productType: "ביטקס שנתי", price: "2800" },
      { productType: "סילבר זום", price: "1,450" },
      { productType: "גולד זום", price: "1,450" },
      { productType: "פלטינום זום", price: "1,450" },
      { productType: "סילבר עם מנוי שנתי", price: "150" },
      { productType: "גולד עם מנוי שנתי", price: "150" },
      { productType: "פלטינום עם מנוי שנתי", price: "150" },

      { productType: "סילבר פרונטלי", price: "1450" },
      { productType: "גולד פרונטלי", price: "1450" },
      { productType: "פלטינום פרונטלי", price: "1450" },
      { productType: "סילבר + גולד פרונטלי", price: "2400" },
      { productType: "גולד + פלטינום פרונטלי", price: "2400" },
      { productType: "סילבר + גולד + פלטינום פרונטלי", price: "3450" },

      { productType: "סילבר + גולד בזום", price: "1490" },
      { productType: "גולד + פלטינום בזום", price: "1490" },
      { productType: "סילבר + גולד + פלטינום בזום", price: "1790" },

      { productType: "קורס שמאים", price: "1250" },
      { productType: "צעד ראשון", price: "3600" },
      { productType: "מילניום", price: "3600" },

      { productType: "פאנל", price: "550" },
      { productType: "פאנל הנחה של אלי", price: "290" },

      { productType: "Bquick חודשי", price: "800" },
      { productType: "Bquick שנתי", price: "800" }
    ];
  },
  //get client product statuses by type from server
  //and store them to prevent unnecessary calls
  getClientProductStatuses: function (productTypes) {
    return new Promise((resolve) => {
      if (!productTypes || !Array.isArray(productTypes) || productTypes.join(",") === "") return resolve([]);
      //if it is already stored - no need for more requests
      if (productTypes.every((type) => clientProductStates[type] && clientProductStates[type].length)) return resolve(clientProductStates);
      const query = `clientProductTypes=${productTypes?.join(",")}`;
      const url = `${config.getClientProductStatesEndpoint}?${query}`;
      axios.get(url).then((serverRes) => {
        const productStates = serverRes?.data?.productStates;
        if (serverRes?.data?.success && productStates) {
          clientProductStates = {};
          //make obj of statuses with key as product type such as {btax:[],courses:[]} to store
          productStates.forEach((prod) => {
            prod.usedInProducts.forEach((prodType) => {
              if (!clientProductStates[prodType] && productTypes.includes(prodType)) clientProductStates[prodType] = [];
              if (productTypes.includes(prodType)) clientProductStates[prodType].push(prod);
            });
          });
          return resolve(clientProductStates);
        }
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getAllProductStates: async function () {
    try {
      const res = await axios.get(config.getAllProductStatesEndpoint);
      if (res.data.success) return res.data.allProductStates;
    } catch (err) {
      console.log(err);
    }
  },

  addNewProductState: async function (newStateInfo) {
    try {
      const res = await axios.post(config.addProductStateEndpoint, { newStateInfo });
      if (res.data.success) return res.data;
    } catch (err) {
      console.log(err);
    }
  },

  editProductStateType: async function (stateType, id) {
    try {
      const res = await axios.post(config.editProductStateTypeEndpoint, { stateType, id });
      if (res.data.success) return res.data;
    } catch (err) {
      console.log(err);
    }
  },

  deleteProductStateType: async function (stateType, id, stateName) {
    try {
      const res = await axios.post(config.deleteProductStateTypeEndpoint, { stateType, id, stateName });
      if (res.data.success) return res.data;
    } catch (err) {
      console.log(err);
    }
  },

  deleteProductState: async function (id, stateName) {
    try {
      const res = await axios.post(config.deleteProductStateEndpoint, { id, stateName });
      if (res.data.success) return res.data;
    } catch (err) {
      console.log(err);
    }
  },

  getClientJobOptions: function () {
    return [
      { key: "lawyer", label: "עו״ד" },
      { key: "accountant", label: "רואה חשבון" },
      { key: "shamai", label: "שמאי" },
      { key: "adviser", label: "יועץ מס" },
      { key: "yazam", label: "יזם" },
      { key: "lawyerAndAccountant", label: "עו״ד ורואה חשבון" },
      { key: "lawyerAndShamai", label: "עו״ד ושמאי" },
      { key: "adviserAndAccountant", label: "יועץ מס ורואה חשבון" },
      { key: "jobOther", label: "אחר" }
    ];
  },

  getArrivedFromOpts: function () {
    return [
      { key: "approachedUs", label: "פנייה עצמאית" },
      { key: "websiteSigned", label: "הרשמה לאתר" },
      { key: "leadFromClient", label: "ליד מלקוחות" },
      { key: "facebookLead", label: "ליד פרסום פייסבוק" },
      { key: "mailing", label: "דיוור" },
      { key: "psakDinLead", label: "ליד פרסום פסק דין" },
      { key: "linkedin", label: "linkedin" },
      { key: "nevo", label: "נבו" },
      { key: "otherCompanyLead", label: "ליד פרסום חברה חיצונית" },
      { key: "other", label: "אחר" }
    ];
  },

  getCorrectDateFormat: function (date, time) {
    if (!date) return "";
    var splitDate = date.split("-");

    if (time) {
      var splitTime = time.split(":");
      return new Date(splitDate[0], parseInt(splitDate[1]) - 1, splitDate[2], splitTime[0], splitTime[1]);
    }
    return new Date(splitDate[0], parseInt(splitDate[1]) - 1, splitDate[2]);
  },

  adminGetMembersData: function () {
    return new Promise((resolve) => {
      axios.get(config.adminGetMembersDataEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  uploadEpisodes: (videoDetails) => {
    return axios.post(config.uploadEpisodesEndpoint, { videoDetails }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  updateEpisode: (videoDetails) => {
    return axios.post(config.updateEpisodeEndpoint, { videoDetails }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  getCourseVideos: (id) => {
    return axios.post(config.getCourseVideosEndpoint, { id }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  getCourses: () => {
    return axios.get(config.getCoursesEndpoint).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  deleteEpisode: (id) => {
    return axios.post(config.deleteEpisodeEndpoint, { id }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  addCourse: (courseInfo) => {
    return axios.post(config.addCourseEndpoint, { courseInfo }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  updateCourse: (courseInfo) => {
    return axios.post(config.updateCourseEndpoint, { courseInfo }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  deleteCourse: (id) => {
    return axios.post(config.deleteCourseEndpoint, { id: id }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  getAllowedUsers: () => {
    return axios.get(config.getAllowedUsersEndpoint).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  addAllowedUser: (userInfo) => {
    return axios.post(config.addAllowedUserEndpoint, { userInfo }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  updateAllowedUser: (updates) => {
    return axios.post(config.updateAllowedUserEndpoint, { updates }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  },

  deleteAllowedUser: (id) => {
    return axios.post(config.deleteAllowedUserEndpoint, { id }).then((serverRes) => {
      if (serverRes.data) return serverRes.data;
      return { err: "Problem with the request" };
    });
  }
};

function getSimilarVars(data) {
  const toReturn = { officeName: data.officeName, tzNum: data.tzNum };
  for (let i = 0; i < 8; i++) {
    if (data["contactEmail" + i]) toReturn["contactEmail" + i] = data["contactEmail" + i];
    if (data["mobile" + i]) toReturn["mobile" + i] = data["mobile" + i];
  }
  return toReturn;
}

function buildGetReqUrl(endpoint, querys = {}) {
  //build url from endpoint and querys (obj like - {searchKey:"ab",client:"john"})
  const urlQueryPart = `${Object.entries(querys)
    .map((entry) => `${entry[0]}=${entry[1]}`)
    .join("&")}`;
  const url = `${endpoint}?${urlQueryPart}`;
  return url;
}

function isValidEmail(email = "") {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
